import NotificationBadge from './NotificationBadge'

export default NotificationBadge
